import { TimeLogApi, ToastStateHandler } from '../../../api';
import { SubmitTimelogByOwnerDto } from '../../../commonTypes/timelog.types';
import { dispatch } from '../../../store';
import { addSubmissionIntervalOfProject } from '../../../store/slices/time-tracking.slice';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';

const useHttpSubmitTimelogs = () => {
    const { t } = useTranslation('newNotifications');
    const timeLogApi: TimeLogApi = useContainer(TimeLogApi);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);

    const exec = (body: SubmitTimelogByOwnerDto, onSuccessCallback?: () => void) => {
        const { exec, abort } = timeLogApi.submitTimelogByOwner({
            body,
            onSuccess: res => {
                dispatch(addSubmissionIntervalOfProject(res.body));
                toastHandler.push('success', t('timelog.timesheetSubmissionTitle'), t('timelog.timesheetSubmissionSuccess'));
                if (onSuccessCallback) {
                    onSuccessCallback();
                }
            },
            onError: error => {
                if (error.includes('overlapping'))
                    return toastHandler.push('warn', t('timelog.ownerSubmissionTitle'), t('timelog.ownerSubmissionWarnOverlapingIntervals'));
                if (error.includes(`don't have time logs to submit`))
                    return toastHandler.push('warn', t('timelog.ownerSubmissionTitle'), t('timelog.ownerSubmissionWarnNoTimeLogsInInterval'));
            },
        });
        exec();
        return abort;
    };

    return { exec };
};

export default useHttpSubmitTimelogs;
